var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import math from "polished/lib/math/math";
import { mergeDeepRight, path, pathOr } from "ramda";
export var extendTheme = function (theme, extension) { return mergeDeepRight(theme, extension); };
export var propOrElse = function (pathName, defaultValue) { return function (props) { return pathOr(defaultValue, pathName, props); }; };
export var getOrElse = function (pathName, defaultValue) { return function (_a) {
    var theme = _a.theme;
    return pathOr(defaultValue, pathName, theme);
}; };
export var getSizeUnit = function (_a) {
    var theme = _a.theme;
    return path(["constants", "SIZE_UNIT"], theme);
};
export var calcSize = function (expr) { return function (props) {
    if (expr) {
        var exprWithGap = expr.replace("_", "".concat(getSizeUnit(props)));
        return math(exprWithGap);
    }
    return getSizeUnit(props);
}; };
export var getColor = function (colorPath) {
    var colorPaths = Array.isArray(colorPath) ? colorPath : [colorPath];
    return getOrElse(__spreadArray(["colors"], colorPaths, true), "#fff");
};
export var getRgbColor = function (colorPath, opacity) {
    if (opacity === void 0) { opacity = 1; }
    return function (_a) {
        var theme = _a.theme;
        var color = getColor(colorPath)({ theme: theme });
        var bigint = parseInt(color.substring(1), 16);
        var r = (bigint >> 16) & 255;
        var g = (bigint >> 8) & 255;
        var b = bigint & 255;
        return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(opacity, ")");
    };
};
export var getSizeBy = function (multiplier) {
    if (multiplier === void 0) { multiplier = 1; }
    return function (props) {
        var size = (getSizeUnit(props) || 0) * multiplier;
        return "".concat(size, "px");
    };
};
export var getGutterHeight = function (_a) {
    var theme = _a.theme;
    var gutterValue = path(["constants", "GUTTER_HEIGHT"], theme) || 0;
    return "".concat(gutterValue, "px");
};
export var getValidatedControlColor = function (defaultColorPath, defaultDisabledPAth) {
    if (defaultColorPath === void 0) { defaultColorPath = "border"; }
    if (defaultDisabledPAth === void 0) { defaultDisabledPAth = "disabled"; }
    return function (_a) {
        var theme = _a.theme, success = _a.success, error = _a.error, disabled = _a.disabled;
        if (success)
            return getColor(["success"])({ theme: theme });
        if (error)
            return getColor(["error"])({ theme: theme });
        if (disabled)
            return getColor([defaultDisabledPAth])({ theme: theme });
        return getColor([defaultColorPath])({ theme: theme });
    };
};
